import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../redux/authSlice';

const Header = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  const [showProfilePopover, setShowProfilePopover] = useState(false);
  const popoverRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setShowProfilePopover(false);
      }
    };

    if (showProfilePopover) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfilePopover]);

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-dark bg-teal">
        <div className="container">
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img src={logo} alt="VakraLabs" style={{ height: '50px' }} className="me-2" />
            <div>
              <div>Vakralabs Services</div>
              <div className="text-light d-none d-md-block" style={{ fontSize: '0.6rem', fontFamily: 'cursive' }}>Simplifying Complexity to Deliver Creativity</div>
            </div>
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <div className="navbar-nav ms-auto d-flex align-items-center">
              <Link className="nav-link" to="/">Home</Link>
              {/*  {isAuthenticated && <Link className="nav-link" to="/dashboard">Dashboard</Link>}
              {isAuthenticated && <Link className="nav-link" to="/recharge">Recharge</Link>} */}
              {isAuthenticated && <Link className="nav-link" to="/farmer">Farmer Report</Link>}

              <Link className="nav-link" to="/services">Services</Link>
             {/*  <Link className="nav-link" to="/pricing">Pricing</Link> */}
              <Link className="nav-link" to="/blog/shg">Blogs</Link>
              <Link className="nav-link" to="/careers">Careers</Link>

              <Link className="nav-link" to="/contact">Contact US</Link>
              <Link className="nav-link" to="/about">About US</Link>
              {/*               {!isAuthenticated && <Link className="nav-link" to="/login">Login</Link>}
 */}              {isAuthenticated && (
                <div className="position-relative" ref={popoverRef}>
                  <button
                    className="btn btn-link nav-link border-0 p-0 ms-2"
                    onClick={() => setShowProfilePopover(!showProfilePopover)}
                  >
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: '35px', height: '35px' }}>
                      👤
                    </div>
                  </button>
                  {showProfilePopover && (
                    <div className="position-absolute end-0 mt-2 bg-white border rounded shadow" style={{ minWidth: '200px', zIndex: 1000 }}>
                      <div className="p-3">
                        <div className="text-center mb-2">
                          <div className="rounded-circle bg-light d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: '50px', height: '50px' }}>
                            👤
                          </div>
                          <h6 className="mb-1">{user?.fullName || 'User'}</h6>
                          <small className="text-muted">{user?.mobileNumber}</small> <br />
                          <small className="text-muted">{user?.email}</small>

                        </div>
                        <hr />
                        {/* <Link to="/profile" className="btn btn-outline-teal btn-sm w-100 mb-2" onClick={() => setShowProfilePopover(false)}>View Profile</Link> */}
                        <button onClick={handleLogout} className="btn btn-danger">Logout</button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;